/* eslint-disable react/no-did-update-set-state */
import React, { Fragment, PureComponent } from 'react';
import PropTypes from 'prop-types';

export default class Image extends PureComponent {
  static propTypes = {
    children: PropTypes.oneOfType([
      PropTypes.node,
      PropTypes.func,
      PropTypes.element
    ]).isRequired,
    src: PropTypes.string.isRequired,
    fallbackSrc: PropTypes.string,
    placeholderSrc: PropTypes.string,
    delay: PropTypes.number
  };

  static defaultProps = {
    fallbackSrc:
      'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII=',
    placeholderSrc:
      'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII=',
    delay: 0
  };

  state = {
    src: this.props.placeholderSrc,
    loading: true,
    error: false
  };

  componentDidMount() {
    const { src } = this.props;

    this.loadImage(src);
  }

  componentDidUpdate(prevProps) {
    const { src, placeholderSrc } = this.props;
    if (src !== prevProps.src) {
      this.setState({ image: placeholderSrc, loading: true }, () => {
        this.loadImage(src);
      });
    }
  }

  componentWillUnmount() {
    this.resetImageListeners();
  }

  loadImage = src => {
    this.resetImageListeners();

    this.image = new window.Image();
    this.image.onload = this.onImageLoad;
    this.image.onerror = this.onImageError;
    this.image.src = src;
  };

  onImageLoad = () => {
    const { delay } = this.props;

    setTimeout(() => {
      this.setState({ src: this.image.src, loading: false });
    }, delay);
  };

  onImageError = () => {
    const { fallbackSrc } = this.props;

    this.setState({ src: fallbackSrc, loading: false });
  };

  resetImageListeners() {
    if (this.image) {
      this.image.onload = null;
      this.image.onerror = null;
    }
  }

  render() {
    const { children } = this.props;

    return (
      <Fragment>
        {typeof children === 'function'
          ? children({ ...this.state })
          : children}
      </Fragment>
    );
  }
}
